import { render } from "./inventory.vue?vue&type=template&id=c4a81312&scoped=true"
import script from "./inventory.vue?vue&type=script&lang=js"
export * from "./inventory.vue?vue&type=script&lang=js"

import "./inventory.vue?vue&type=style&index=0&id=c4a81312&lang=scss&scoped=true"

import exportComponent from "/var/jenkins_home/workspace/jk-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4a81312"]])

export default __exports__